<mg-country
  *ngIf="country$ | async"
  [country]="$any(country$ | async)"
  [hideText]="hideText"></mg-country>
